import type { TemplateMeta } from '../../types';
import { ListVerticalIcon } from './Icon';

export const listVerticalMeta: TemplateMeta = {
  name: 'List',
  orientation: 'portrait',
  Icon: ListVerticalIcon,
  theme: 'background',
  eventListDisplayCustomLabel: 'Date range',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'date-range',
};
